import React, { Component } from 'react';
import UserAPIs from '../../APIs/UserAPIs';

const PASS_NO_MATCH_ERR = 'Passwords doesn\'t match';

export default class ForgotPassword extends Component {
    state = {
        otpWait: false,
        email: '',
        emailErr: '',
        otp: '',
        otpErr: '',
        password: '',
        passwordErr: '',
        rPassword: '',
        rPasswordErr: '',
        submitErr: '',
        submitMsg: '',
        submitMsg2: '',
        busy: false,
    }
    // first view submit button
    sendOtp = (cb) => {
        if(this.state.busy) return;
        const { email } = this.state;
        if(email) {
            this.setState({ submitErr: '', busy: true });
            window.grecaptcha.execute('6LczXf0UAAAAAENBT-2jze2A0c_FGMEp90z_13gp', {action: 'sendotp'}).then(token => {
                UserAPIs.getEmailOtp({ username: email, captcha: token }).then(rsp => {
                    this.setState({otpWait: true, busy: false}, cb);
                }).catch(err => {
                    if(err.response) {
                        this.setState({submitErr: err.response.data.msg, busy: false})
                    }
                })
            })
        }
    }
    // second view submit button
    resetPassword = () => {
        if(this.state.busy) return;
        let { email: username, otp, password, rPassword } = this.state;
        let newState = {
            submitErr: '',
            // passwordErr: '',
            submitMsg: ''
        }
        let valid = true;
        newState.rPasswordErr = password !== rPassword ? PASS_NO_MATCH_ERR : '';
        if(password !== rPassword) valid = false;
        if(valid) newState.busy = true;
        this.setState(newState);
        if(!valid) return;
        window.grecaptcha.execute('6LczXf0UAAAAAENBT-2jze2A0c_FGMEp90z_13gp', {action: 'resetpassword'}).then(token => {
            UserAPIs.resetPassword({
                username,
                otp,
                password,
                recaptcha: token,
            }).then(rsp => {
                this.setState({ submitMsg: 'Password successfully reset' })
                const time = parseInt(new Date().valueOf() / 1000, 10) + 3;
                setInterval(() => {
                    let now = parseInt(new Date().valueOf() / 1000, 10);
                    this.setState({ submitMsg2: 'Reloading in ' + Math.max(0, time - now) + '...'})
                }, 1000);
                setTimeout(() => {
                    window.location.reload();
                }, 3000);
            }).catch(err => {
                if(err.response) {
                    this.setState({ submitErr: err.response.data.msg, busy: false })
                }
            })
        })
    }
    // validate password field (onChange handler)
    onPasswordChange = ({target: { value: password }}) => {
        const { email: username, rPassword } = this.state;
        const rPasswordErr = rPasswordErr && rPassword !== password ? PASS_NO_MATCH_ERR : '';
        this.setState({ password, rPasswordErr });
        if(password) {
            clearTimeout(this.passwordcheck);
            this.passwordcheck = setTimeout(() => {
                UserAPIs.validatePassword({ username, password }).then(rsp => {
                    this.setState({passwordErr: rsp.data.valid ? '' : rsp.msg});
                });
            }, 250);
        }
    }
    // validate confirm password field (onChange handler)
    onRPasswordChange = ({target: { value: rPassword }}) => {
        this.setState({rPassword, rPasswordErr: rPassword !== this.state.password ? PASS_NO_MATCH_ERR : ''})
    }
    // resend otp button handler
    regenOtp = () => {
        this.setState({
            otp: '',
            password: '',
            rPassword: '',
        })
        this.sendOtp(() => {
            this.setState({ submitErr: '', submitMsg: 'OTP has been resent' });
        });
    }
    // submit on enter pressed handler
    onKeyDown = e => {
        if(e.keyCode === 13) {
            if(this.state.otpWait) this.resetPassword();
            else this.sendOtp();
        }
    }
    otpChanged = ({target: { value }}) => {
        if(value.length <= 6) {
            this.setState({otp: value.replace(/\D/g, '')});
        }
    }
    render() {
        let inputHandler = (key, onChange) => {
            if(!onChange) onChange = ({target: { value }}) => this.setState({ [key]: value })
            return {
                onChange,
                value: this.state[key],
                onKeyDown: this.onKeyDown,
            }
        }
        return <div className="imp-w">
            <div className={'imp-wc fp' + (this.state.busy ? ' busy' : '')}>
            {this.state.otpWait ? <div className="imp-st fp">
                <h1>Reset password</h1>
                <div className="et">
                    <div>OTP sent to</div>
                    <div>{this.state.email}</div>
                </div>
                <div className="grp">
                    <input {...inputHandler('otp', this.otpChanged)} type="text" placeholder="OTP" />
                    {this.state.otpErr && <div className="err">{this.state.otpErr}</div>}
                </div>
                <div className="grp">
                    <input  {...inputHandler('password', this.onPasswordChange)} type="password" placeholder="New password" />
                    {this.state.passwordErr && <div className="err">{this.state.passwordErr}</div>}
                </div>
                <div className="grp">
                    <input {...inputHandler('rPassword', this.onRPasswordChange)} type="password" placeholder="Confirm Password" />
                    {this.state.rPasswordErr && <div className="err">{this.state.rPasswordErr}</div>}
                </div>
                <div><button className={'sbtn'} onClick={this.resetPassword}>Submit</button></div>
                {this.state.submitErr && <div className="err ctr">{this.state.submitErr}</div>}
                {/* these are known messages from the api */}
                {['Incorrect OTP', 'OTP expired'].includes(this.state.submitErr) && <div className="lnk"><button onClick={this.regenOtp}>Resend OTP</button></div>}
                {this.state.submitMsg && <div className="msg">{this.state.submitMsg}</div>}
                {this.state.submitMsg2 && <div className="msg">{this.state.submitMsg2}</div>}
            </div> : <div className="imp-st">
                <h1>Forgot password</h1>
                <div className="grp">
                    <input {...inputHandler('email')} type="text" placeholder="Email" />
                    {this.state.emailErr && <div className="err">{this.state.emailErr}</div>}
                </div>
                <div><button className="sbtn" onClick={this.sendOtp}>Send OTP</button></div>
                {this.state.submitErr && <div className="err ctr">{this.state.submitErr}</div>}
            </div>}
            </div>
        </div>
    }
}